import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

class BasicCustomerCard extends ApplicationComponent {
  render() {
    return (
      <div>
        <div className="flex items-center justify-between">
          <div className="text-lg font-bold">{this.props.customerName}</div>
          <div className="space-x-1">{this.props.children}</div>
        </div>
        <div>{this.props.email}</div>
        <div>{this.props.phone}</div>
      </div>
    )
  }
}

BasicCustomerCard.propTypes = {
  customerName: PropTypes.string.isRequired,
  email: PropTypes.string,
  phone: PropTypes.string,
  children: PropTypes.node,
}

export default BasicCustomerCard
